export const USER_INFO_API_PATH = "/api/techpub/v1/user-details";
export const VIRTUAL_CLASS_ROOM_OR_ENGINES_API_PATH = "/api/techpub/v1/virtual-classroom-or-engines";
